// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].use[2]!../variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\---ui-components-src-buttons---Toggle-module__status {
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1em;
  width: var(--mechanic-input-height-quart);
  height: var(--mechanic-input-height-quart);
  border-radius: var(--mechanic-input-height-eighth);
  border: 1px solid currentColor;
}

.\\---ui-components-src-buttons---Toggle-module__status.\\---ui-components-src-buttons---Toggle-module__on {
    background: currentColor;
  }

.\\---ui-components-src-buttons---Toggle-module__label {
}

.\\---ui-components-src-buttons---Toggle-module__focus .\\---ui-components-src-buttons---Toggle-module__status {
  margin-left: -1px;
}
`, "",{"version":3,"sources":["webpack://./../ui-components/src/buttons/Toggle.module.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,yCAAyC;EACzC,0CAA0C;EAC1C,kDAAkD;EAClD,8BAA8B;AAIhC;;AAHE;IACE,wBAAwB;EAC1B;;AAGF;AACA;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../variables.css\";\n\n.status {\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 1em;\n  width: var(--mechanic-input-height-quart);\n  height: var(--mechanic-input-height-quart);\n  border-radius: var(--mechanic-input-height-eighth);\n  border: 1px solid currentColor;\n  &.on {\n    background: currentColor;\n  }\n}\n\n.label {\n}\n\n.focus .status {\n  margin-left: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
export var status = `---ui-components-src-buttons---Toggle-module__status`;
export var on = `---ui-components-src-buttons---Toggle-module__on`;
export var label = `---ui-components-src-buttons---Toggle-module__label`;
export var focus = `---ui-components-src-buttons---Toggle-module__focus`;
export default ___CSS_LOADER_EXPORT___;
